import { useState } from 'react';

const formatPrice = (n) => `₪${Number(n).toFixed(2)}`;

// הכתובת מה-API של הפלטפורמה היא תבנית: .../{{size}}.{{extension||'jpg'}}
const imageSrc = (url) => url ? url.replace('{{size}}', 'medium').replace(/\{\{extension[^}]*\}\}/, 'jpg') : null;

const s = {
  row:       { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 14, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 12 },
  imageBox:  { width: 72, height: 72, flex: '0 0 72px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa', borderRadius: 8, overflow: 'hidden' },
  image:     { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' },
  noImage:   { fontSize: 11, color: '#8c959f' },
  info:      { flex: '1 1 220px', minWidth: 0 },
  name:      { fontWeight: 600, fontSize: 16 },
  meta:      { color: '#59636e', fontSize: 13, marginTop: 2 },
  prices:    { display: 'flex', gap: 8, flex: '1 1 260px' },
  store:     { flex: 1, minWidth: 110, border: '1px solid #e5e7eb', borderRadius: 10, padding: '8px 10px', background: '#fff' },
  cheapest:  { borderColor: '#2da44e', background: '#effaf2' },
  missing:   { background: '#f6f8fa', color: '#8c959f' },
  storeName: { fontSize: 13, color: '#59636e', display: 'flex', justifyContent: 'space-between', gap: 6 },
  badge:     { fontSize: 11, fontWeight: 600, color: '#1a7f37' },
  price:     { fontSize: 20, fontWeight: 700 },
  perKg:     { fontSize: 12, fontWeight: 400, color: '#59636e', marginInlineStart: 4 },
  promo:     { marginTop: 4, fontSize: 12, color: '#9a6700', background: '#fff8c5', borderRadius: 6, padding: '2px 6px', display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  diff:      { flex: '0 0 120px', textAlign: 'center' },
  diffValue: { fontSize: 18, fontWeight: 700, color: '#cf222e' },
  diffPct:   { fontSize: 13, color: '#59636e' },
  diffNone:  { fontSize: 13, color: '#59636e' },
};

// שורת מוצר: המחיר בכל סופר, הזול מסומן, וההפרש
const ProductRow = ({ item, stores, prices }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const src = imageSrc(item.imageUrl);

  const meta = [
    item.brandName,
    item.isWeighable ? 'שקיל' : (item.weight && item.unitName ? `${Number(item.weight)} ${item.unitName}` : null),
    item.barcode ? `ברקוד ${item.barcode}` : null,
  ].filter(Boolean).join(' · ');

  const onlyStore = item.storeCount === 1 ? stores.find((st) => prices[st.id]) : null;

  return (
    <div style={s.row}>
      <div style={s.imageBox}>
        {src && !imageFailed
          ? <img style={s.image} src={src} alt="" loading="lazy" onError={() => setImageFailed(true)} />
          : <span style={s.noImage}>אין תמונה</span>}
      </div>

      <div style={s.info}>
        <div style={s.name}>{item.name}</div>
        {meta && <div style={s.meta}>{meta}</div>}
      </div>

      <div style={s.prices}>
        {stores.map((st) => {
          const p = prices[st.id];
          if (!p) {
            return (
              <div key={st.id} style={{ ...s.store, ...s.missing }}>
                <div style={s.storeName}>{st.name}</div>
                <div>לא נמכר</div>
              </div>
            );
          }
          const isCheapest = item.cheapestStoreId === st.id;
          return (
            <div key={st.id} style={{ ...s.store, ...(isCheapest ? s.cheapest : null) }}>
              <div style={s.storeName}>
                <span>{st.name}</span>
                {isCheapest && <span style={s.badge}>הכי זול</span>}
              </div>
              <div style={s.price}>
                <span className="num">{formatPrice(p.price)}</span>
                {item.isWeighable && <span style={s.perKg}>לק"ג</span>}
              </div>
              {p.promotionTag && <div style={s.promo} title={p.promotionTag}>{p.promotionTag}</div>}
            </div>
          );
        })}
      </div>

      <div style={s.diff}>
        {onlyStore ? (
          <div style={s.diffNone}>נמכר רק ב{onlyStore.name}</div>
        ) : item.priceDiff > 0 ? (
          <>
            <div style={s.diffValue} className="num">{formatPrice(item.priceDiff)}</div>
            <div style={s.diffPct}>הפרש של {Number(item.diffPct)}%</div>
          </>
        ) : (
          <div style={s.diffNone}>אותו מחיר</div>
        )}
      </div>
    </div>
  );
};

export default ProductRow;
